export const LARGE_HEADER_FONT = 40;
export const LOGO_FONT = 25;
export const HEADER_FONT = 20;
export const SUB_HEADER_FONT = 16;
export const BODY_FONT = 16;
export const FOOTER_FONT = 16;
